module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--04.ff822226.png";